// AppButton.js — Standard button styles across the app.
//
//   variant="primary"   solid blue (#1D4ED8) — the single primary action
//   variant="secondary" white with 1px gray-300 border — Cancel / Save as Draft
//   variant="danger"    solid red (#B91C1C) — delete/destructive only
//   variant="ghost"     transparent, no border — Back, tertiary Cancel
//
// Do not use MUI color/variant combinations outside these four for actions.
// Text-only buttons are not used for Cancel; links are allowed inline in body text.
import React from 'react';
import { Button } from '@mui/material';

const VARIANT_PROPS = {
  primary: { variant: 'contained', color: 'primary' },
  secondary: { variant: 'outlined', color: 'inherit' },
  danger: { variant: 'contained', color: 'error' },
  ghost: { variant: 'text', color: 'inherit' },
};

export default function AppButton({ variant = 'primary', sx = {}, children, ...props }) {
  const v = VARIANT_PROPS[variant] || VARIANT_PROPS.primary;
  const ghostSx = variant === 'ghost'
    ? {
        color: 'text.primary',
        '&:hover': { bgcolor: 'grey.100' },
      }
    : {};
  return (
    <Button variant={v.variant} color={v.color} sx={{ ...ghostSx, ...sx }} {...props}>
      {children}
    </Button>
  );
}
